import React from 'react';
import { chargeCenterRoute } from '@/modules/charge-center/route';
import { createRoute } from '@tanstack/react-router';

// ! This may need some re-evaluation
export const historicalUptimeRoute = createRoute({
  getParentRoute: () => chargeCenterRoute,
  path: 'historical-uptime',
  component: React.lazy(async () => await import('@/app/routes/Analytics')),
  wrapInSuspense: true,
});
